module.exports = __webpack_public_path__ + "static/bk-5-6a4d21cf4304e453b98187d18f01d6b7.png";